import React, { useEffect, useState } from 'react';
import { TextField, Autocomplete, Chip } from '@mui/material';
import ObtenerPlanes from '../functions/ObtenerPlanes';
import ObtenerPrestador from '../functions/ObtenerPrestador';
import ObtenerEspecialidadesPorPrestador from '../functions/ObtenerEspecialidadesPorPrestador';
import PlanSeleccionar from '../types/PlanSeleccionar';
import PrestadorSeleccionar from '../types/PrestadorSeleccionar';
import ObtenerPrestadorEspecialidades from '../functions/ObtenerPrestadorEspecialidades';

interface SeleccionarPlanesProps {
    elPrestador: PrestadorSeleccionar;
    onChange: (plan: PlanSeleccionar) => void;
    onRemove: (plan: PlanSeleccionar) => void;
    onClear: () => void;
    eliminando: boolean;
  }

const SeleccionarPlanes: React.FC<SeleccionarPlanesProps> = ({ elPrestador, onChange, onRemove, onClear, eliminando }) => {

    const [prestador, setPrestador] = useState<PrestadorSeleccionar>({id: 0, prestador: '', especialidades: [], planes: []});
    const [planes, setPlanes] = useState<PlanSeleccionar[]>([]);

    const fetchDatosIniciales = async () => {
        
        // Recupero los datos de los planes
        const dataPlanes = await ObtenerPlanes("activos");

        if (dataPlanes.planes_ok === 'si') {

            const planesRecuperados: PlanSeleccionar[] = [];
            for (const plan of dataPlanes.planes) {
                planesRecuperados.push({
                    id: plan.id,
                    title: plan.title
                });
            }

            setPlanes(planesRecuperados);    

            if (elPrestador.id > 0) {
                
                setPrestador(elPrestador);
            }
        }
    };

    const onChangeLocal = (plan: PlanSeleccionar) => {
        // Need to update the planes array with the new plan
        const planesCopy = [...prestador.planes];
        planesCopy.push(plan);
        setPrestador({
            ...prestador,
            planes: planesCopy
        });
        onChange(plan);
    }

    const onRemoveLocal = (plan: PlanSeleccionar) => {
        // Need to update the planes array removing the plan
        const planesCopy = prestador.planes.filter((item) => item.id !== plan.id);
        setPrestador({
            ...prestador,
            planes: planesCopy
        });
        onRemove(plan);
    }

    const onClearLocal = () => {
        setPrestador({
            ...prestador,
            planes: []
        });
        onClear();
    };

    useEffect(() => {
        fetchDatosIniciales()
    }, []);

    /*useEffect(() => {
        fetchRubros()
    }, [rubroInicial]);*/

    return (
        <div className="flex flex-col w-full">
            {/*<Autocomplete
                multiple
                options={especialidades}
                getOptionLabel={(option) => option.especialidad}
                value={prestador.especialidades}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, newValue) => {
                    onChange(newValue[0]);
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        label="Especialidades"
                        placeholder="Seleccionar especialidades"
                    />
                )}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                    <Chip
                        variant="outlined"
                        label={option.especialidad}
                        {...getTagProps({ index })}
                    />
                    ))
                }
            />*/}
            <Autocomplete
                multiple
                id="planes"
                size="small"
                options={planes}
                getOptionLabel={(option) => option.title}
                value={prestador.planes}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, newValue, reason, details) => {
                    if (reason === 'selectOption') {
                        if (details?.option) {
                            onChangeLocal(details.option);
                        }
                    } else if (reason === 'removeOption') {
                        if (details?.option) {
                            onRemoveLocal(details.option);
                        }
                    } else if (reason === 'clear') {
                        onClearLocal();
                        onClear();
                    }
                }}
                renderTags={(value, getTagProps) =>
                value.map((option, index) => {
                    const { key, ...tagProps } = getTagProps({ index });
                    return (
                        <Chip
                            key={key}
                            variant="filled"
                            label={option.title}
                            size="small"
                            {...tagProps}
                        />
                    );
                })
                }
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="outlined"
                        label="Planes del Prestador"
                        placeholder="Planes"
                    />
                )}
                disabled={eliminando}
            />
        </div>
    );
}

export default SeleccionarPlanes;